var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumberger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5C15.8807 5 17 3.88071 17 2.5C17 1.11929 15.8807 0 14.5 0C13.1193 0 12 1.11929 12 2.5C12 3.88071 13.1193 5 14.5 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 5C27.8807 5 29 3.88071 29 2.5C29 1.11929 27.8807 0 26.5 0C25.1193 0 24 1.11929 24 2.5C24 3.88071 25.1193 5 26.5 5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17C15.8807 17 17 15.8807 17 14.5C17 13.1193 15.8807 12 14.5 12C13.1193 12 12 13.1193 12 14.5C12 15.8807 13.1193 17 14.5 17Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17C3.88071 17 5 15.8807 5 14.5C5 13.1193 3.88071 12 2.5 12C1.11929 12 0 13.1193 0 14.5C0 15.8807 1.11929 17 2.5 17Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 17C27.8807 17 29 15.8807 29 14.5C29 13.1193 27.8807 12 26.5 12C25.1193 12 24 13.1193 24 14.5C24 15.8807 25.1193 17 26.5 17Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C15.8807 29 17 27.8807 17 26.5C17 25.1193 15.8807 24 14.5 24C13.1193 24 12 25.1193 12 26.5C12 27.8807 13.1193 29 14.5 29Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 29C3.88071 29 5 27.8807 5 26.5C5 25.1193 3.88071 24 2.5 24C1.11929 24 0 25.1193 0 26.5C0 27.8807 1.11929 29 2.5 29Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 29C27.8807 29 29 27.8807 29 26.5C29 25.1193 27.8807 24 26.5 24C25.1193 24 24 25.1193 24 26.5C24 27.8807 25.1193 29 26.5 29Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumberger);
export default __webpack_public_path__ + "static/media/Humberger.50cebee03492d8c773d9597e175823ba.svg";
export { ForwardRef as ReactComponent };